import declare from "dojo/_base/declare";
import Key from "csi/core/Key";
import { featureTogglesStore } from "csi/state/rootStore";
import TableWidget from "csi/table/Widget";
import { C8AttributeKey } from "src/c8-platform/type/value";

export = declare(TableWidget, {
	/**
	 * @override
	 * Hide the Composition Type column if the material composition feature flag is turned off
	 */
	onViewResolveKeysToSkip(skipSet: Set<C8AttributeKey>): void {
		// FIX: a better way to do this would be to disable the BO attribute - then it would not show up at all in the UI
		if (!featureTogglesStore.MATERIAL_COMPOSITION) {
			skipSet.add(Key.untypedKeyFromParts({
				id: "SustainabilityCompositionType",
			}));
		}
	},
});
